import React, { useEffect } from 'react';
import ReactQuill, { Quill } from 'react-quill';

import { CustomAnchor } from './CustomBlot';
Quill.register(CustomAnchor);

export const emailTemplatePlaceholder = [
  {
    mailTemplate: [
      'Candidate first name',
      'Candidate name',
      'Candidate email',
      'Customer first name',
      'Customer name',
      'Company name',
      'Dashboard URL',
      'Job Title',
      'Score',
      'Test ticket URL',
      'Test',
      'Time',
      'Invite link',
    ],
  },
];

const editorConfig = {
  modules: {
    toolbar: {
      container: [
        [{ header: '1' }, { header: '2' }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['code-block', 'link', 'clean'],
        emailTemplatePlaceholder,
      ],
      handlers: {
        mailTemplate: function (value) {
          if (value) {
            let placeholderText = '[' + value.replace(/\s/g, '-').toLowerCase() + ']';
            let cursorPosition = this.quill.getSelection().index;
            this.quill.insertText(cursorPosition, placeholderText);
            this.quill.setSelection(cursorPosition + placeholderText.length);
          }
        },
      },
    },
  },
  formats: ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'link', 'align', 'code-block', 'customAnchor'],
};

const getEditorConfig = (addPlaceholder) => {
  if (addPlaceholder) return editorConfig;
  let copy = JSON.parse(JSON.stringify(editorConfig));
  copy.modules.toolbar.container.pop();
  return copy;
};

export default function QuillEditor({ value, className, placeholder, onChange, addPlaceholder, height }) {
  const editor = getEditorConfig(addPlaceholder);

  useEffect(() => {
    setTimeout(() => {
      let elements = document.getElementsByClassName(`quill ${className}`);
      for (const element of elements) {
        if (element.lastChild && height) element.lastChild.style.height = height;
      }
    });
    if (addPlaceholder) {
      const placeholderPickerItems = Array.prototype.slice.call(
        document.querySelectorAll('.ql-mailTemplate .ql-picker-item')
      );
      placeholderPickerItems.forEach((item) => (item.textContent = item.dataset.value));
    }
  }, [className, addPlaceholder, height]);

  return (
    <ReactQuill
      modules={editor.modules}
      formats={editor.formats}
      placeholder={placeholder}
      value={value}
      className={className}
      onChange={(updatedValue, delta, source) => onChange(updatedValue, delta, source)}
      preserveWhitespace={true}
    />
  );
}
